import { ListClinic } from '@chiroup/core/types/Clinic.type';
import { useDebounce } from '@chiroup/hooks/useDebounce';
import { useState } from 'react';
import { QueryFunctionContext, useInfiniteQuery } from 'react-query';
import clinicService from '../services/clinic.service';

const getQuery = () => {
  return async (context: QueryFunctionContext) => {
    const searchTerm = context.queryKey[1] as string;
    const search = searchTerm || '';

    return clinicService.list({ skip: context.pageParam, search });
  };
};

const useClinics = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearch = useDebounce(searchQuery);
  const {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery<{ data: ListClinic[]; skip: number }>(
    ['clinics', debouncedSearch],
    getQuery(),
    {
      getNextPageParam: lastGroup => lastGroup?.skip || undefined,
      refetchOnWindowFocus: false,
    }
  );

  const onSearch = (params: string) => {
    setSearchQuery(params);
  };

  return {
    status,
    data,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
    onSearch,
  };
};

export default useClinics;
